<template>
  <v-container fluid>
    <br>
    <h2 class="title-style">
      <v-icon class="icon-style">
        mdi-pencil
      </v-icon> Edit Digi-Board
    </h2>
    <v-card
      class="my-base-vcard-style"
    >
      <br>
      <v-card
        class="my-vcard-style"
      >
        <v-card-text>
          <v-form
            ref="form"
            v-model="valid"
          >
            <v-col
              cols="12"
              sm="12"
            >
              <v-text-field
                v-model="digiBoardLocation"
                label="Digi-Board Location*"
                :rules="[(v) => !!v || 'This field is required']"
              />
            </v-col>
            <v-row>
              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  v-model="digiBoardExternalId"
                  label="Digi-board Id*"
                  disabled
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  v-model="digiBoardNumber"
                  label="Board Number"
                  hint="Name for your reference - 'BOARD_DBSYS_001'."
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                sm="6"
              >
                <v-select
                  v-model="selectedHostOrganizationId"
                  menu-props="auto"
                  :items="organizationList"
                  hint="By choosing an organization, It's Id will get fetched."
                  :rules="[(v) => !!v || 'This field is required']"
                  item-value="external_id"
                  prepend-icon="mdi-domain"
                  item-text="name"
                  label="Select Host Organization*"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-select
                  v-model="timeZone"
                  menu-props="auto"
                  :items="timeZonesByName"
                  label="Select Time Zone*"
                  prepend-icon="mdi-clipboard-text-clock-outline"
                  :rules="[(v) => !!v || 'This field is required']"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                sm="6"
              >
                <v-select
                  v-model="digiBoardType"
                  menu-props="auto"
                  :items="digiBoardTypes"
                  item-value="id"
                  item-text="name"
                  label="DigiBoard Type*"
                  :rules="[(v) => !!v || 'This field is required']"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  v-model="slotDuration"
                  label="Slot Duration*"
                  type="number"
                  :rules="[(v) => !!v || 'This field is required']"
                  hint="For Reference - '30'."
                  persistent-hint
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                md="6"
                sm="12"
              >
                <div class="my-card-style">
                  <font class="my-dimension-style">
                    Screen Dimension
                  </font>
                  <v-radio-group
                    v-model="selectedScreenDimension"
                    row
                    align-content="center"
                    justify="center"
                    class="my-radio-btn-style"
                    @change="changeScreenDimension()"
                  >
                    <v-radio
                      label="Landscape "
                      value="landscape"
                    />
                    <v-radio
                      label="Portrait"
                      value="portrait"
                    />
                  </v-radio-group>
                  <v-row class="my-dimension-row-style">
                    <div class="my-div-style">
                      <v-text-field
                        v-model="height"
                        label="Height"
                        outlined
                        dense
                        type="number"
                        class="my-dimension-field-style"
                      />
                      <font class="my-font-style">
                        X
                      </font>
                      <v-text-field
                        v-model="width"
                        label="Width"
                        outlined
                        type="number"
                        dense
                        class="my-dimension-field-style"
                      />
                    </div>
                  </v-row>
                </div>
              </v-col>
            </v-row>
          </v-form>
          <br>
          <br>
          <p class="text-sm-left">
            *Indicates required field
          </p>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="red darken-3"
            @click="$router.push({ name: 'DigiBoards' })"
          >
            Back
          </v-btn>
          <v-spacer />
          <v-btn
            class="mt-2"
            color="#FF3700"
            @click="update()"
          >
            Update
          </v-btn>
        </v-card-actions>
      </v-card>
      <br>
    </v-card>
    <centre-spinner
      :loading="loading"
    />
  </v-container>
</template>
<script>
  import Constants from 'src/constants';
  import spinner from 'src/views/dashboard/component/SpinnerCentre';

  export default {
    name: 'EditDigiBoard',
    components: {
      'centre-spinner': spinner,
    },
    data () {
      return {
        digiBoardLocation: '',
        digiBoardNumber: null,
        timeZone: '',
        selectedHostOrganizationId: '',
        valid: false,
        loading: false,
        height: null,
        width: null,
        digiBoardType: '',
        slotDuration: null,
        digiBoardExternalId: '',
        selectedScreenDimension: '',
      };
    },
    computed: {
      organizationList () {
        const fetchedOrganizationsList = this.$store.getters['organizations/getOrganizationList'];
        const filteredHostOrganizations = fetchedOrganizationsList.filter(i => i.category === 'host');
        return filteredHostOrganizations;
      },
      allTimeZones () {
        return this.$store.getters['users/getTimeZones'];
      },
      timeZonesByName () {
        return Object.keys(this.allTimeZones).map((key) => ({ text: key, value: this.allTimeZones[key] }));
      },
      digiBoardTypes () {
        return this.$store.getters['digiboards/getDigiBoardTypesList'];
      },
      digiBoardDetails () {
        return this.$store.getters['digiboards/getDigiBoardDetails'];
      },
    },
    async mounted () {
      this.loading = true;
      await this.fillData();
      await this.$store.dispatch('organizations/fetchOrganizationList');
      await this.getAllTimeZone();
      await this.getDigiBoardTypes();
      this.loading = false;
    },
    methods: {
      async fillData () {
        this.loading = true;
        const digiBoardId = this.$route.params.id;
        await this.$store.dispatch('digiboards/fetchDigiBoardDetails', {
          params: {
            digiBoardId: digiBoardId,
          },
        }).then(response => {
          this.digiBoardLocation = this.digiBoardDetails.location;
          this.digiBoardNumber = this.digiBoardDetails.board_number;
          this.digiBoardExternalId = this.digiBoardDetails.external_id;
          this.timeZone = this.digiBoardDetails.timezone;
          this.selectedHostOrganizationId = this.digiBoardDetails.organization.external_id;
          this.height = this.digiBoardDetails.height;
          this.width = this.digiBoardDetails.width;
          this.digiBoardType = this.digiBoardDetails.digi_board_specification.id;
          this.slotDuration = this.digiBoardDetails.total_duration;
          this.loading = false;
        }).catch(() => {
          this.loading = false;
        });
      },
      async update () {
        if (this.$refs.form.validate() === false) {
          this.$store.dispatch('alert/onAlert', {
            message: 'Please fill the required fields before proceeding.',
            type: Constants.ALERT_TYPE_ERROR,
          }, { root: true });
          return;
        }
        this.loading = true;
        const digiBoardExternalId = this.$route.params.id;
        await this.$store.dispatch('digiboards/updateDigiBoardDetails', {
          digiBoardDetails: {
            location: this.digiBoardLocation,
            board_number: this.digiBoardNumber,
            timezone: this.timeZone,
            organization_id: this.selectedHostOrganizationId,
            digi_board_specification_id: this.digiBoardType,
            total_duration: parseInt(this.slotDuration),
            height: this.height,
            width: this.width,
          },
          digiBoardId: digiBoardExternalId,
        }).then(response => {
          this.$store.dispatch('alert/onAlert', {
            message: 'Digi-Board updated successfully.',
            type: Constants.ALERT_TYPE_SUCCESS,
          });
          this.loading = false;
          this.$router.push({ name: 'DigiBoards' });
        }).catch(() => {
          this.loading = false;
        });
      },
      async getAllTimeZone () {
        await this.$store.dispatch('users/fetchTimeZones');
      },
      changeScreenDimension () {
        if (this.selectedScreenDimension === 'portrait') {
          this.height = '1920';
          this.width = '1080';
        } else {
          this.height = '1080';
          this.width = '1920';
        }
      },
      async getDigiBoardTypes () {
        await this.$store.dispatch('digiboards/fetchDigiBoardTypesList');
      },
    },
  };
</script>
<style scoped>
.my-vcard-style {
  margin-right: 30px;
  margin-left: 30px;
  background-color: #ECEFF1;
  border-radius: 25px;
}
.my-base-vcard-style {
  background-color: #CFD8DC !important;
}
.title-style {
  color: #37474F;
}
.icon-style {
  color: #37474F;
  font-size: 45px;
}
.my-font-style {
  padding-top: 4px;
  margin: 4px;
  margin-right: 10px;
  margin-left: 10px;
  height: 40px;
}
.my-dimension-row-style {
  padding-left: 25px;
  margin-top: 2px;
}
.my-dimension-field-style {
  width: 90px;
}
.my-div-style {
  display: flex;
}
.my-dimension-style {
  font-weight: bold;
  margin-left: 35px;
}
.my-radio-btn-style {
  margin-top: 10px !important;
  margin-left: 10px;
}
.my-card-style {
  border-left: 5px solid #FF3700 !important;
  margin-left: 10px;
}
</style>
